import React from 'react';
import DashboardPrimaryActionButton from './DashboardPrimaryActionButton';
import { renderMaintTag, renderServiceTag } from './DashboardStatusTags';

export default function DashboardForkliftMobileCard({
  forklift,
  navigate,
  onSelect,
  selected,
  maintenancePathBase = '/customer/maintenance',
  missingUnitLabel = '—',
}) {
  const unitId = forklift.unitId || missingUnitLabel;
  return (
    <article
      className={`dashboard-fleet-forklift-card shared-selected-card${selected ? ' is-selected' : ''}`}
      onClick={onSelect}
    >
      <div className="dashboard-fleet-forklift-card-header">
        {forklift.unitId ? (
          <DashboardPrimaryActionButton
            type="link"
            className="dashboard-fleet-unit-link dashboard-fleet-forklift-unit-link"
            onClick={() =>
              navigate(
                `${maintenancePathBase}?unitId=${encodeURIComponent(forklift.unitId)}`
              )
            }
          >
            {unitId}
          </DashboardPrimaryActionButton>
        ) : (
          <span className="dashboard-fleet-forklift-unit-missing">{unitId}</span>
        )}
        <div className="dashboard-fleet-forklift-badges">
          {renderServiceTag(forklift.status)}
          {renderMaintTag(forklift.maintenanceStatus)}
        </div>
      </div>
      <dl className="dashboard-fleet-forklift-details">
        <div>
          <dt>Make / Model</dt>
          <dd>{[forklift.make, forklift.model].filter(Boolean).join(' / ') || '—'}</dd>
        </div>
        <div>
          <dt>Serial #</dt>
          <dd>{forklift.serialNumber || '—'}</dd>
        </div>
        <div>
          <dt>Hours</dt>
          <dd>{forklift.hourMeter || forklift.hourMeter === 0 ? forklift.hourMeter : '—'}</dd>
        </div>
      </dl>
    </article>
  );
}
